import { z } from "zod";

import { bank } from "./banks";
import { typeSearchParam } from "@/filters";
import { defaultTypeCriteria } from "@/constants";

export const uf = z.enum(
  [
    "ac",
    "al",
    "am",
    "ap",
    "ba",
    "ce",
    "df",
    "es",
    "go",
    "ma",
    "mg",
    "ms",
    "mt",
    "pa",
    "pb",
    "pe",
    "pi",
    "pr",
    "rj",
    "rn",
    "ro",
    "rr",
    "rs",
    "sc",
    "se",
    "sp",
    "to",
  ],
  { required_error: "Informe o estado do imóvel" }
);

export const houseCAIXA = z.object({
  id: z.number(),
  uf,
  cidade: z.string(),
  bairro: z.string(),
  endereco: z.string(),
  preco: z.number(),
  valor_de_avaliacao: z.number(),
  desconto: z.number(),
  descricao: z.string(),
  modalidade_de_venda: z.string(),
  link: z.string(),
});

export const houseSantander = z.object({
  codigo: z.number(),
  descTipoImovel: z.string().transform((value) => value.toLowerCase()),
  logradrouro: z.string(),
  numeroResidencia: z.string(),
  bairroDeclarado: z.string(),
  descCidade: z.string(),
  desagio: z.number(),
  uf: z.string(),
  urlLink: z.string(),
  dataLeilao: z.coerce.date().nullable(),
  valorAvaliado: z.number(),
  valorVenda: z.number().nullable(),
  area: z.number().nullable(),
  areaUtil: z.number().nullable(),
  areaTotal: z.number().nullable(),
  areaPrivativa: z.number(),
  vagas: z.number(),
  dormitorios: z.number(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  thumbnail: z.string().nullable(),
});

export const houseBradesco = z.object({
  guid: z.string(),
  auction_date: z.coerce.date().nullable(),
  date_auction_1: z.coerce.date().nullable(),
  date_auction_2: z.coerce.date().nullable(),
  final_date_auction: z.coerce.date().nullable(),
  category: z.string().transform((value) => {
    if (value === "Imóvel Comercial") return "comercial";
    if (value === "Sala/Escritório") return "sala";

    return value.toLowerCase();
  }),
  city: z.string(),
  state: z.string(),
  description: z.string(),
  realstate_auction_type: z.enum(["alienacao-fiduciaria", "convencional"]),
  price: z.number(),
  min_auction_value_1: z.number().nullable(),
  min_auction_value_2: z.number().nullable(),
  final_auction_value: z.number().nullable(),
  images: z.array(z.string()).transform((value) => value.toString()),
  name: z.string(),
  neighborhood: z.string(),
  slug: z.string(),
});

export const housesCAIXA = z.array(houseCAIXA);
export const housesSantander = z.array(houseSantander);
export const housesBradesco = z.array(houseBradesco);

export const house = houseCAIXA
  .omit({
    preco: true,
    descricao: true,
    valor_de_avaliacao: true,
    modalidade_de_venda: true,
  })
  .merge(
    z.object({
      id: z.string(),
      banco: bank,
      cidade_descricao: z.string(),
      criado_em: z.string(),
      novo: z.boolean().default(false),
      numero_do_leilao: z.string(),
      descricao: z.string(),
      data_de_licitacao1: z.number().nullable(),
      data_de_licitacao2: z.number().nullable(),
      preco_atual: z.number().nullable(),
      preco1: z.number().nullable(),
      preco2: z.number(),
      valor_de_avaliacao: z.number(),
      modalidade_de_venda: z.string(),
      tipo: z.enum(typeSearchParam).exclude([defaultTypeCriteria]),
      total_area: z.number().nullable(),
      total_area_privativa: z.number().nullable(),
      total_area_terreno: z.number().nullable(),
      inscricao_imobiliaria: z.string().nullable(),
      comarca: z.string(),
      averbacao: z.string().nullable(),
      matricula: z.string().nullable(),
      edital: z.string().nullable(),
      situacao: z.string().nullable(),
      numero_do_item_edital: z.string().nullable(),
      imagens: z.array(z.string()),
      aceita_fgts: z.boolean().nullable().default(false),
      aceita_financiamento: z.boolean().nullable().default(false),
      aceita_parcelamento: z.boolean().nullable().default(false),
      aceita_consorcio: z.boolean().nullable().default(false),
      aceita_a_vista: z.boolean().nullable().default(false),
      area_nao_averbada: z.boolean().nullable().default(false),
      acoes_judiciais: z.array(z.string()),
      valor_de_desconto: z.number(),
      valor_lucro_liquido_sozinho: z.number(),
      valor_lucro_liquido_com_corretor: z.number(),
      roi_solo: z.number(),
      roi_com_corretor: z.number(),
      valor_gasto_mensal: z.object({
        total: z.number(),
        valor_condominio: z.number(),
        valor_IPTU: z.number(),
        valor_financiamento: z.number(),
      }),
      valor_gasto_inicial: z.object({
        total: z.number(),
        valor_entrada_de_financiamento: z.number(),
        valor_comissao_de_leiloeiro: z.number(),
        valor_ITBI: z.number(),
        valor_registro_de_imovel: z.number(),
        valor_FRJ: z.number(),
      }),
      projecao_de_lucro: z.array(
        z.object({
          mes: z.number(),
          valor_gasto_total: z.number(),
          valor_lucro_liquido_sozinho: z.number(),
          valor_lucro_liquido_com_corretor: z.number(),
          roi_solo: z.number(),
          roi_com_corretor: z.number(),
        })
      ),
      favorito: z.boolean().default(false).optional().default(false),
    })
  );
